import { render } from "./teaZcEchart.vue?vue&type=template&id=dd485164&scoped=true"
import script from "./teaZcEchart.vue?vue&type=script&lang=js"
export * from "./teaZcEchart.vue?vue&type=script&lang=js"

import "./teaZcEchart.vue?vue&type=style&index=0&id=dd485164&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd485164"]])

export default __exports__